/**
 * login
 */

import Container from '@/containers';

const loginRouter = {
    path: '/login',
    component: Container,
    redirect: '/login/index',
    name: 'login',
    meta: {
        title: '登录'
    },
    children:[
        {
        path: '/login',
        component: () => import('@/views/login'),
        name: '登录页',
        meta: {
                title: '学术交流登录页',
                index:1
            }
        }
    ]
};

export default loginRouter;